<script lang="ts" setup>
    import {
        BarController,
        BarElement,
        CategoryScale,
        Chart as ChartJS,
        Legend,
        LinearScale,
        LineController,
        LineElement,
        PointElement,
        Title,
        Tooltip,
    } from 'chart.js';
    import { reactive } from 'vue';
    import { Chart } from 'vue-chartjs';
    import { PageTimeStat } from '../interfaces';
    import { surveyChartData, surveyChartOptions } from './surveyChartConfig';

    const { pageTimeStats } = defineProps<{
        pageTimeStats: PageTimeStat[];
    }>();

    ChartJS.register(CategoryScale, LinearScale, BarElement, LineElement, PointElement, Title, Tooltip, Legend, BarController, LineController);
    const chartData = reactive(surveyChartData(pageTimeStats));
    const options = surveyChartOptions(pageTimeStats);
</script>
<template>
    <template v-if="chartData?.datasets?.length > 0">
        <div class="chart-wrapper">
            <Chart type="bar" :data="chartData" :options="options" />
        </div>
    </template>
    <template v-else>
        <div class="chart-wrapper">
            <p>{{ $Resources.SurveyChartNoData }}</p>
        </div>
    </template>
</template>

<style scoped>
    .chart-wrapper {
        position: relative;
        display: flex;
    }
</style>
